<template>
  <div class="home-section">
    <h1>{{ title }}</h1>
    <p class="description" v-for="(desc, index) in descriptions" :key="index">
      {{ desc }}
    </p>
    <p class="images">
      <img v-for="(img, index) in images"
        :key="index"
        :src="img.src"
        :alt="img.alt"
        :class="'max-width-' + img.width + 'pc'">
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    description: [String, Array],
    images: {
      type: Array,
      default () {
        return []
      }
    }
  },

  computed: {
    descriptions () {
      return this.description instanceof Array ? this.description : [this.description]
    }
  }
}
</script>

<style lang="scss" scoped>
  .description {
    max-width: 640px;
    margin-bottom: 30px;
  }
  .images {
    img {
      margin-right: 5%;

      @media screen and (max-width: 500px) {
        display: inline-block;
        max-width: 90%;
        margin-right: 0;
        margin-bottom: 3rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HomeSection.vue